import { Input } from "antd";
import React, { useState } from "react";

const FyzksInput = (props) => {
  const [focus, setFocus] = useState(false);
  const { children, label, value, onEnter, width, style, ...restProps } = props;

  const labelClass = focus || value ? "label label-float" : "label";

  // Don't apply width as inline style - let CSS handle responsive widths
  // Only apply other style props if provided
  const inputStyle = style || {};

  return (
    <Input
      onPressEnter={() => { onEnter && onEnter() }}
      value={value}
      {...restProps}
      style={inputStyle}
    />
  );
};

export default FyzksInput;
